  window.addEventListener('DOMContentLoaded', () => {
    const variantsJSONSRC = document.getElementById('product-variants-data');
    if(!variantsJSONSRC) return;

    const variantsJson = variantsJSONSRC.textContent;
    const variantsData = JSON.parse(variantsJson);
    
    if(!variantsData) return;
    
    const variantSelectors = Array.from(document.querySelectorAll('.product-badge-toggler'));
    const colorSelectors = Array.from(document.querySelectorAll('.product-badge-toggler.selector-color'));
    //const variantBadges = Array.from(document.querySelectorAll('.variant-quantity-badge'));
    const atcLabel = document.querySelector('.product-button-pricing__label');

    //if(!variantSelectors || !variantBadges) return;

    if(!variantSelectors.length) return;

    variantSelectors.forEach(selector => {
      selector.addEventListener('change', event => {
        toggleBadges();
      })
    });

    toggleBadges();

    function toggleBadges() {
      const selectedVariantName = variantSelectors.filter(item => item.checked).map(item => item.getAttribute('value')).join(' / ');
      const selectedVariantID = variantsData.filter(item => item.title === selectedVariantName).map(item => item.id);
      
      // const badgeSelector = `.variant-quantity-badge[data-variant-id="${selectedVariantID}"]`;
      // const currentBadge = document.querySelector(badgeSelector);

      // variantBadges.forEach(badge => badge.setAttribute('data-enabled', false));
      // currentBadge.setAttribute('data-enabled', true);

      const variantAvailable = variantsData.filter(item => item.id === selectedVariantID[0]).map(item => item.available);
      if(atcLabel) {
        if(variantAvailable[0]) {
          atcLabel.innerHTML = `
            Dodaj u korpu
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_1197_3476)">
                    <path d="M5 12H5.5M8.5 12H10M13 12H19" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15 16L19 12" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M15 8L19 12" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </g>
                <defs>
                    <clipPath id="clip0_1197_3476">
                        <rect width="24" height="24" fill="white"/>
                    </clipPath>
                </defs>
            </svg>
          `
        }else {
          atcLabel.innerHTML = "RASPRODATO"
        }
      }
    }

    function toggleColorSelectors(input) {
      console.log("Input: ", input)
      const quantityData = input.getAttribute('data-variant-quantity')
      
      if(!quantityData) return;

      const variantQuantity = quantityData.split(',');

      if(!colorSelectors) return;
      colorSelectors.forEach(color => {
        color.disabled = false
        color.classList.remove('disabled')
      })

      variantQuantity.forEach(quantity => {
        if(quantity > 0) return;

        const index = variantQuantity.indexOf(quantity);

        colorSelectors[index].classList.add('disabled');
      })
    }
  })